import React, { useState, useCallback, useContext } from 'react';
import { StreamMessage } from 'utils/messages/StreamMessage';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import classnames from 'classnames';
import { IconNames } from '@instinet-analytics/semantic-ui-components';

import './WidgetMessage.scss';
import { MessageIcon } from '@instinet-analytics/semantic-ui-components';
import AppContext from 'app/AppContext';

export interface WidgetMessageProps {
    streamMessage: StreamMessage;
}

export function WidgetMessage(props: WidgetMessageProps) {
    const { streamMessage } = props;

    const { timeFormat, services } = useContext(AppContext);
    const { loggingService } = services;
    const message = getMessage(streamMessage);

    const [expanded, setExpanded] = useState(false);
    const [isLong, setIsLong] = useState(false);

    const toggleExpanded = () => setExpanded(!expanded);

    const measuredRef = useCallback((node: HTMLDivElement | null) => {
        if (!node) {
            return;
        }
        const { offsetHeight, scrollHeight } = node;
        setIsLong(scrollHeight > offsetHeight);
    }, []);

    return (
        <div className="WidgetMessage">
            <div className="icon-area">
                <MessageIcon />
            </div>
            <div className={classnames('content', expanded && 'expanded')}>
                {expanded ? (
                    <div onClick={toggleExpanded}>
                        <div className="message">{message}</div>
                        <div className="details-toggle">
                            Hide details
                            <Icon name={'chevron up' as IconNames} />
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="message" ref={measuredRef}>
                            {message}
                        </div>
                        {isLong && (
                            <div
                                className="details-toggle"
                                onClick={toggleExpanded}
                            >
                                Show details
                                <Icon
                                    name={'chevron down' as IconNames}
                                    onClick={toggleExpanded}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );

    function getMessage(streamMessage: StreamMessage): string {
        let ret = streamMessage.message;
        try {
            if (streamMessage.date) {
                ret +=
                    ' unavailable until ' +
                    timeFormat.toTimeMinutes(streamMessage.date!);
            }
        } catch (err) {
            loggingService.warn(
                'WidgetMessage',
                'Invalid Message Date',
                streamMessage
            );
        }
        return ret;
    }
}
